import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Table,
  TableContainer,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from '@chakra-ui/react'
import { formatPrice } from '../../../utils/formatPrice'
import { format } from 'date-fns'

export function ModalParcelas({ item, parcelas }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  console.log(item)
  return (
    <>
      <Button size="xs" variant="outline" onClick={onOpen}>
        {parcelas}
      </Button>

      <Modal size="3xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Parcelas</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <TableContainer>
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>Parcela</Th>
                    <Th>Status</Th>
                    <Th isNumeric>Data do Vencimento</Th>
                    <Th isNumeric>Valor da Parcela</Th>
                    <Th isNumeric>Taxa</Th>
                    <Th isNumeric>Valor Real</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {item?.map((parcela) => (
                    <Tr key={parcela.parcela}>
                      <Td>{parcela.parcela}</Td>
                      <Td>{parcela.status}</Td>
                      <Td>{parcela.data_vencimento ? format(new Date(parcela.data_vencimento), 'dd/MM/yyyy') : ''}</Td>
                      <Td>{formatPrice(parcela.valor_parcela)}</Td>
                      <Td>{parcela.taxa}</Td>
                      <Td>{formatPrice(parcela.valor_real)}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
